import { render, staticRenderFns } from "./NewAlbum.vue?vue&type=template&id=172fcd5c&"
import script from "./NewAlbum.vue?vue&type=script&lang=js&"
export * from "./NewAlbum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports